import {
  CustomFieldSelectAttribute,
  CustomFieldStringAttributeValue,
  CustomFieldStringListAttributeValue,
  CustomFieldTextAttribute,
} from 'apis/customFields';

import { CustomField } from '../useLazyCustomFields';

export const isTextCustomField = (
  customField: CustomField,
): customField is CustomField<
  CustomFieldTextAttribute,
  CustomFieldStringAttributeValue
> => {
  return customField.attribute.type === 'text';
};

export const isSelectCustomField = (
  customField: CustomField,
): customField is CustomField<
  CustomFieldSelectAttribute,
  CustomFieldStringListAttributeValue
> => {
  return customField.attribute.type === 'select';
};
